import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'nova-custom-field-grid-viewer-table',
    templateUrl: './custom-field-grid-viewer-table.component.html',
    styleUrls: ['./custom-field-grid-viewer-table.component.scss'],
    standalone: true,
    imports: [CommonModule, MatTableModule, MatTooltipModule]
})
export class CustomFieldGridViewerTableComponent {
    @Input() values = [];
    @Input() isLoading = true;
    displayedColumns: string[] = ['name', 'value'];

    constructor() {}
}
